import { useDispatch, useSelector } from 'react-redux';
import PendingCard from '@/components/Dashboard/DashboardPendings/PendingsCard';
import GenericBarChart from '../../../Charts/GenericBarChart';
import { setEntryDate } from '@/store/slices/components/dashboard/DashboardSlice';
import {
  MAP_OPERATIONS,
  PROPERTY_OPERATIONS,
} from '@/components/Dashboard/constants';
import { getHeaderUrl, handleClickBar } from './utils';
import RadioButtonsGroup from '@/components/Dashboard/RadioButtonsGroup';
import { getOverviewEntryDate } from '@/store/slices/components/dashboard/service';
import useFetchDashboard from '@/components/Dashboard/customHooks/useFetchDashboard';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import PropertyIcon from '@/public/images/dashboard/property.svg';
import DashboardEmptyStateCard from '@/components/Dashboard/DashboardEmptyStateCard';
import { useTrackOverviewTab } from '@/components/Dashboard/customHooks/useTrackDashboard';

export default function EntryDate() {
  const dispatch = useDispatch();
  const { overviewEntryDate, miniCards } = useSelector(
    (state) => state.DashboardSlice
  );
  const { selectedIds } = useSelector((state) => state.FilterBarSlice.filters);
  const track = useTrackOverviewTab();
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();

  const { loading, hasFetched, labels, datasets, selectedOperation } =
    overviewEntryDate;

  const { selectedStatusId: statusId, propertiesValue } = miniCards;
  const operationId = MAP_OPERATIONS[selectedOperation];

  useFetchOnViewport(
    (query) => {
      dispatch(getOverviewEntryDate({ query, operationId, statusId }));
    },
    [statusId, operationId],
    { hasFetched }
  );

  const headerUrl = getHeaderUrl(operationId, statusId, selectedIds);

  const handleClickRadio = (operation) => {
    dispatch(
      setEntryDate({
        key: 'selectedOperation',
        value: operation.id,
      })
    );
  };

  const allowedOptions = [
    { id: PROPERTY_OPERATIONS.SALE, text: Trans(translations, 'Sale') },
    { id: PROPERTY_OPERATIONS.RENT, text: Trans(translations, 'Rent') },
    {
      id: PROPERTY_OPERATIONS.TEMPORARY,
      text: Trans(translations, 'Temporary'),
    },
  ];

  return (
    <PendingCard ref={ref} loading={loading || isStale}>
      <PendingCard.Header
        redirectUrl={propertiesValue === 0 ? null : headerUrl}
        toolTipText={Trans(translations, 'ShowAll')}
        trackCallback={(element) => track.propertyEntryDate(element)}
      >
        {Trans(translations, 'EntryDate')}
      </PendingCard.Header>
      {propertiesValue === 0 ? (
        <DashboardEmptyStateCard
          icon={PropertyIcon}
          title={Trans(
            translations,
            'HereYouWillSeeTheNumberOfPropertiesEnteredInDifferentTimePeriods'
          )}
        />
      ) : (
        <>
          <RadioButtonsGroup
            onClickRadio={handleClickRadio}
            selectedOption={selectedOperation}
            allowedOptions={allowedOptions}
          />
          <GenericBarChart
            labels={labels}
            datasets={datasets}
            onBarClick={
              selectedIds.length > 1
                ? null
                : ({ label }) =>
                    handleClickBar(
                      operationId,
                      statusId,
                      selectedIds,
                      label.range
                    )
            }
          />
        </>
      )}
    </PendingCard>
  );
}
